const FAQS = [
  {
    q: 'Do you support WordPress or similar CMS?',
    a: 'No we do not, we only host static websites.'
  },
  {
    q: 'What is a static website?',
    a:'A static website is a website that appears the same to all visitors and does not require a backend server or database to render it. It\'s composed of frontend only static files such as such as HTML, JavaScript and images (jpeg, png, svg etc).'
  },
  {
    q: 'Do you support e-commerce sites?',
    a: 'We do not in the traditional CMS way (WordPress, Joomla etc), but we do support static e-commerce sites.'
  },
  {
    q: 'What\'s the fastest way to reach you in case I need help?',
    a: 'Send us a message via the chat icon in the bottom right-hand corner or an email at support@tiiny.host. We\'re quick to respond and always happy to help. Our goal is to make web hosting as simple as possible.'
  },
  {
    q: 'How does your 7 day money back guarantee work?',
    a: 'We have many happy customers. However, if for some reason after you upgrade to one of our paid plans you decide that it\'s not for you, then just reach out to our friendly support within 7 days and we\'ll be happy to give you a full refund.',
  },
  {
    q: 'Can I cancel at anytime?',
    a: 'Of course! If you no longer need us, just cancel your subscription via your control panel. We process subscriptions through Stripe - which also manages thousands of other subscription services.'
  },
  {
    q: 'What happens after I cancel?',
    a: 'Your sites will remain live until the end of your billing period. After this time, we\'ll completely remove them along with your account from our servers.'
  },
]

export default FAQS;